export default "__VITE_ASSET__BgKnN1SA__"